const m = {
  hourTip: 'Select Hour',
  minuteTip: 'Select Minute',
  secondTip: 'Select Second',
  second: 's',
  yearSuffix: 'Year',
  monthsHead: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
  months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
  weeks: 'Mon_Tue_Wed_Thu_Fir_Sat_Sun',
  hello: 'Hello',
  helloMessage: 'Welcome Back, Apache SkyWalking APM System !',
  username: 'Username',
  password: 'Password',
  title: 'Title',
  width: 'Width',
  height: 'Height',
  login: 'Login Now',
  signout: 'Sign Out',
  dashboard: 'Dashboard',
  topology: 'Topology',
  trace: 'Trace',
  alarm: 'Alarm',
  auto: 'Auto',
  reload: 'Reload',
  usermode: 'User Mode',
  editmode: 'Edit Mode',
  currentService: 'Current Service',
  currentEndpoint: 'Current Endpoint',
  currentInstance: 'Current Instance',
  currentDatabase: 'Current Database',
  templateConfig: 'Template Config',
  copy: 'Copy',
  reset: 'Reset',
  apply: 'Apply',
  createGroup: 'Create Group',
  groupType: 'Group Type',
  groupName: 'Group Name',
  template: 'Template',
  confirm: 'Confirm',
  cancel: 'Cancel',
  createTab: 'Create Tab',
  tabName: 'Tab Name',
  nouse: 'No Use',
  allServices: 'All Services',
  serviceDetail: 'Service Detail',
  detectPoint: 'Detect Point',
  callType: 'Call Type',
  server: 'Server',
  client: 'Client',
  name: 'Name',
  type: 'Type',
  cpm: 'Cpm',
  sla: 'SLA',
  latency: 'Latency',
  avgResponseTime: 'Avg Response Time',
  avgThroughput: 'Avg Throughput',
  avgSLA: 'Avg SLA',
  all: 'All',
  success: 'Success',
  error: 'Error',
  service: 'Service',
  instance: 'Instance',
  database: 'Database',
  endpoint: 'Endpoint',
  cache: 'Cache',
  global: 'Global',
  serviceendpoint: 'ServiceEndpoint',
  serviceinstance: 'ServiceInstance',
  status: 'Status',
  endpointName: 'Endpoint Name',
  search: 'Search',
  clear: 'Clear',
  more: 'More',
  traceID: 'TraceID',
  range: 'Range',
  timeRange: 'Time Range',
  duration: 'Duration',
  startTime: 'startTime',
  start: 'Start',
  spans: 'Spans',
  spanInfo: 'Span Info',
  spanType:  'Span Type',
  time: 'Time',
  tags: 'Tags',
  logs: 'Logs',
  component: 'Component',
  table: 'Table',
  list: 'List',
  tree: 'Tree',
  filterScope: 'Filter Scope',
  searchKeyword: 'Search Keyword',
  quarterHourCutTip: 'Last 15 mins',
  halfHourCutTip: 'Last 30 mins',
  hourCutTip: 'Last 1 hour',
  dayCutTip: 'Last 1 day',
  weekCutTip: 'Last 1 week',
  monthCutTip: 'Last 1 month',
  serverZone: 'Server Zone',
  percentResponse: 'Response Time Percentile',
  exportImage: 'Export image',
  comparison: 'Metrics Comparison',
  queryData: 'Query',
  previousService: 'Previous Service',
  nextService: 'Next Service',
  object: 'Object',
  metrics: 'Metrics',
  ShowInstanceDependency: 'Show Instance Dependency',
  InstanceDependencyTitle: 'Service Instance Dependency',
};

export default m;
